import { Observable, Subject } from 'rxjs'

// Subject for opening the menu.
const toggleFieldsAddMenuOpen: Subject<boolean> = new Subject<boolean>()

// Observable for when to open the menu.
export const toggleFieldsAddMenuOpen$: Observable<boolean> = toggleFieldsAddMenuOpen.asObservable()

// Announce when the menu should be opened.
export const announceToggleFieldsAddMenuOpen = (isOpen: boolean): void => toggleFieldsAddMenuOpen.next(isOpen)
